import axios from 'axios';
import Constants from '@/constants';

class ClientService {
    constructor() {
        this.table_name = 'realestate.clients'
    }

    async listSimple() {
        var query = `SELECT id, fullname, phone, address, needs_price_range, sale, status FROM ${this.table_name}`;

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading records');
            return;
        }

        console.log(response.data);
        return response.data
    }

    async listSimple2() {
        var query = `SELECT id, fullname, phone FROM ${this.table_name}`;

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading records');
            return;
        }

        console.log(response.data);
        return response.data
    }
  
    async getDetail(id) {
        if(!id)
            return {};
            
        var query = 'SELECT *';
        query += `FROM ${this.table_name} `;
        query += 'WHERE id=' + id + ';';

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data || response.data.length != 1) {
            alert('Error while downloading record ' + this.id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async getDetailFromView(id, view_name) {
        if(!id)
            return {};
            
        var query = 'SELECT *';
        query += `FROM ${view_name} `;
        query += 'WHERE id=' + id + ';';

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data || response.data.length != 1) {
            alert('Error while downloading record ' + this.id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async updateClientColumn(clientId, column, value, type) {
        var query = '';

        if(type === 'text') {
            query = `UPDATE realestate.clients SET ${column}='${value}' WHERE id=${clientId};`;
        } else if(type === 'number' || type === 'boolean') {
            query = `UPDATE realestate.clients SET ${column}=${value} WHERE id=${clientId};`;
        }

        var url = Constants.HOST_URL + 'runUpdateQuery?query=' + query;
        var response = await axios.get(url);
        if(!response.data) {
            alert('Error while downloading record ' + id);
            return;
        }

        console.log(response.data[0]);
        return response.data[0]
    }

    async deleteClientById(id) {
        var query = `DELETE FROM realestate.clients WHERE id =${id}`;

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);
        }
        catch (e) {
            alert(e);
        }
    }

    async deleteGroupClients(clientIds) {
        var ids = clientIds.join();

        var query = `DELETE FROM realestate.clients WHERE id IN (${ids})`;

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);
        }
        catch (e) {
            alert(e);
        }
    }

    async getClients(params = {}) {
        const { page = 1, limit = 20, filters = [] } = params;
        const offset = (page - 1) * limit;

        let query = `SELECT * FROM realestate.clients_list_filter_2 WHERE 1=1`;
        let countQuery = `SELECT COUNT(*) as total FROM realestate.clients_list_filter_2 WHERE 1=1`;

        // Apply filters
        if (filters && filters.length > 0) {
            filters.forEach(filter => {
                if (filter.value) {
                    if (Array.isArray(filter.value) && filter.value.length > 0) {
                        const values = filter.value.map(v => `'${v}'`).join(',');
                        query += ` AND ${filter.col} IN (${values})`;
                        countQuery += ` AND ${filter.col} IN (${values})`;
                    } else if (!Array.isArray(filter.value)) {
                        query += ` AND ${filter.col} LIKE '%${filter.value}%'`;
                        countQuery += ` AND ${filter.col} LIKE '%${filter.value}%'`;
                    }
                }
                if (filter.from || filter.to) {
                    if (filter.from) {
                        query += ` AND ${filter.col} >= ${filter.from}`;
                        countQuery += ` AND ${filter.col} >= ${filter.from}`;
                    }
                    if (filter.to) {
                        query += ` AND ${filter.col} <= ${filter.to}`;
                        countQuery += ` AND ${filter.col} <= ${filter.to}`;
                    }
                }
            });
        }

        // Add pagination
        query += ` ORDER BY created_at DESC LIMIT ${limit} OFFSET ${offset}`;

        try {
            const [dataResponse, countResponse] = await Promise.all([
                axios.get(Constants.HOST_URL + 'runSelectQuery?query=' + query),
                axios.get(Constants.HOST_URL + 'runSelectQuery?query=' + countQuery)
            ]);

            return {
                data: dataResponse.data || [],
                total: countResponse.data?.[0]?.total || 0
            };
        } catch (error) {
            console.error('Error fetching clients:', error);
            return {
                data: [],
                total: 0
            };
        }
    }
  }
  
  
export default ClientService;